import React from 'react';
import classNames from 'classnames';
import {
  LinkButton,
  useContentElementConfigurationUpdate,
  useDarkBackground
} from 'pageflow-scrolled/frontend';

import styles from './CtaButton.module.css';

export function CtaButton({configuration, sectionProps}) {
  const updateConfiguration = useContentElementConfigurationUpdate();
  const darkBackground = useDarkBackground();

  return (
    <div className={classNames(styles.wrapper,
                               styles[`align-${configuration.alignment}`],
                               styles[`layout-${sectionProps.layout}`])}>
      <LinkButton className={classNames(styles.cta,
                                        darkBackground ? 'scope-lightContent' : 'scope-darkContent',
                                        configuration.typographySize &&
                                        `typography-ctaButton-${configuration.typographySize}`,
                                        configuration.linkButtonVariant &&
                                        `scope-linkButton-${configuration.linkButtonVariant}`,
                                        configuration.variant &&
                                        `scope-ctaButton-${configuration.variant}`)}
                  href={configuration.href || configuration.url}
                  openInNewTab={configuration.openInNewTab}
                  value={configuration.text}
                  linkPreviewPosition="above"
                  actionButtonPosition="outsideLeft"
                  onLinkChange={value => updateConfiguration(value)}
                  onTextChange={text => updateConfiguration({text})} />
    </div>
  );
}
